export const FETCH_EVENTS_SUCCESS =
  "Calendar->entityActions::fetchEventsSuccess";
export const CREATE_EVENT = "Calendar->entityActions::createEvent";
export const UPDATE_EVENT = "Calendar->entityActions::updateEvent";
export const DELETE_EVENT = "Calendar->entityActions::deleteEvent";
export const RESET = "Calendar->entityActions::reset";

export const CREATE_EVENT_IF_NOT_EXISTS =
  "Calendar->entityActions::createEventIfNotExists";
export const UPDATE_EVENT_IF_EXISTS =
  "Calendar->entityActions::updateEventIfExists";
export const DELETE_EVENT_IF_EXISTS =
  "Calendar->entityActions::deleteEventIfExists";

export const updateEvent = (id, data) => {
  return {
    type: UPDATE_EVENT,
    payload: {
      id,
      data
    }
  };
};

export const createEvent = payload => {
  return {
    type: CREATE_EVENT,
    payload
  };
};

export const deleteEvent = id => {
  return {
    type: DELETE_EVENT,
    payload: id
  };
};

export const updateEventIfExists = (id, data) => {
  return {
    type: UPDATE_EVENT_IF_EXISTS,
    payload: {
      id,
      data
    }
  };
};

export const createEventIfNotExists = payload => {
  return {
    type: CREATE_EVENT_IF_NOT_EXISTS,
    payload
  };
};

export const deleteEventIfExists = id => {
  return {
    type: DELETE_EVENT_IF_EXISTS,
    payload: id
  };
};

export const fetchEventsSuccess = ({ start, end, events }) => {
  return {
    type: FETCH_EVENTS_SUCCESS,
    payload: {
      start,
      end,
      events
    }
  };
};

export const reset = () => {
  return {
    type: RESET
  };
};
